import { brand } from '@/config/brands'
import { useUserStore } from '@/stores'

declare const window: Window & { dataLayer?: any[] }

/**
 * 构造 Axon user_data: email 优先真实邮箱,无则用 {memberId}@{品牌小写}.com 构造;
 * Applovin 要求 email 小写,并会在服务端自动 SHA-256,前端无需 hash
 */
function getAxonUserData(): { email: string; user_id: string } | undefined {
  try {
    const { email, memberId } = useUserStore().$state
    if (!memberId)
      return undefined
    return {
      email: (email || `${memberId}@${brand.toLowerCase()}.com`).toLowerCase(),
      user_id: String(memberId),
    }
  }
  catch {
    return undefined
  }
}

export function pushAxonEvent(eventName: string, params: Record<string, any>, options: Record<string, any> = {}) {
  window.dataLayer = window.dataLayer || []

  if (params.items !== undefined)
    window.dataLayer.push({ items: null })

  const userData = getAxonUserData()
  window.dataLayer.push({
    event: eventName,
    ...(userData ? { user_data: userData } : {}),
    ...params,
    ...options,
  })
}

export function buildAxonItem(productId: string | number, productName: string, price: string | number) {
  return {
    item_id: String(productId),
    item_name: productName,
    price: Number(price),
    quantity: 1,
  }
}
